import { Div2Floor } from "../utils/Div2Floor";
import { enumChartElement, enumChartRenderOrder, enumDashStyle, enumFillMode } from "../constants";
import { QElement } from "./QElement";
import { QRect } from "./QRect";
import { SVG_DrawLine } from "../utils/SVG_DrawLine";
import { ThicknessAdjuster } from "../utils/ThicknessAdjuster";
import { XML_DrawLine } from "../utils/XML_DrawLine";

export class QConnectingLine extends QElement {
  constructor() {
    super();
    this.fConnectingLineGroup = null;
    this.fHorzOrientation = false;
    this.fParentPanel = null;
    this.fAssociatedLayouts = null;
    this.fOffsetX = null;
    this.fOffsetY = null;
  }

  InitConnectingLine(connectingLineGroup, parentPanel, associatedLayouts) {
    this.fAssociatedLayouts = associatedLayouts;
    this.fParentPanel = parentPanel;
    this.fConnectingLineGroup = connectingLineGroup;
    this.SetElementType(enumChartElement.connectingLine);
    this.SetZPlane(enumChartRenderOrder.connectingLine);
  }

  IsSelectable() {
    // Use the parent panel to globally enable or disable selection (overrides QElement default behavior)
    return this.fParentPanel.BoxSelectEnabled();
  }

  GetPositionX() {
    var l = this.fConnectingLineGroup.GetLayout();
    var x = l.GetPositionX() + this.fOffsetX;
    return x;
  }

  GetPositionY() {
    var l = this.fConnectingLineGroup.GetLayout();
    var y = l.GetPositionY() + this.fOffsetY;
    return y;
  }

  SetOrientation(horizontal) {
    this.fHorzOrientation = horizontal;
  }

  DrawDashedLine(drawBuffer, sx, sy, ex, ey, thickness, fillColor, selected) {
    var ctx = drawBuffer.getContext("2d");

    ctx.strokeStyle = fillColor;
    ctx.lineWidth = thickness;
    ctx.lineJoin = "miter";
    if (selected) {
      ctx.setLineDash([1, 1]);
    } else {
      var s = 2 + thickness;
      ctx.setLineDash([s, 2]);
    }

    ctx.beginPath();
    ctx.moveTo(sx, sy);
    ctx.lineTo(ex, ey);
    ctx.stroke();
    ctx.setLineDash([]);
  }

  GetLineRect(r) {
    var thickness = this.GetConnectingLineThickness();
    var vertLineSize = this.GetHeight();

    var x = this.GetPositionX();
    var y = this.GetPositionY();
    if (this.fHorzOrientation) {
      r.fLeft = x - Div2Floor(thickness); // Math.floor(thickness/2);
      r.fRight = r.fLeft + this.GetWidth() + thickness;
      r.fTop = y + 2 + ThicknessAdjuster(thickness);
      r.fBottom = r.fTop;
    } else {
      r.fLeft = x + 2 + ThicknessAdjuster(thickness);
      r.fRight = r.fLeft;
      r.fTop = y;
      r.fBottom = r.fTop + vertLineSize;
    }
  }

  GetLineRectAlt(r) {
    //var thickness = this.GetConnectingLineThickness();
    var vertLineSize = this.GetHeight();
    var x = this.GetPositionX();
    var y = this.GetPositionY();

    if (this.fHorzOrientation) {
      r.fLeft = x; // - Div2Floor(thickness);
      r.fRight = r.fLeft + this.GetWidth(); // + thickness;
      r.fTop = y + 2; // + ThicknessAdjuster(thickness);
      r.fBottom = r.fTop;
    } else {
      r.fLeft = x + 2; // + ThicknessAdjuster(thickness);
      r.fRight = r.fLeft;
      r.fTop = y;
      r.fBottom = r.fTop + vertLineSize; // + thickness;
    }
  }

  DrawConnectingLine(drawBuffer, fillColor, dashed, selected) {
    var ctx = drawBuffer.getContext("2d");
    var thickness = this.GetConnectingLineThickness();
    ctx.strokeStyle = fillColor;
    ctx.lineWidth = thickness;
    ctx.lineJoin = "miter";

    var r = new QRect();
    this.GetLineRect(r);

    if (selected) dashed = true;

    if (dashed)
      this.DrawDashedLine(
        drawBuffer,
        r.fLeft,
        r.fTop,
        r.fRight,
        r.fBottom,
        thickness,
        fillColor,
        selected
      );
    else {
      ctx.beginPath();
      ctx.moveTo(r.fLeft, r.fTop);
      ctx.lineTo(r.fRight, r.fBottom);
      ctx.stroke();
    }
  }

  OverrideDashStyle() {
    var layoutList = this.fAssociatedLayouts;
    if (layoutList == null) return null;

    var n = layoutList.length;
    var dashSetting = null;

    for (var i = 0; i < n; i++) {
      var aLayout = layoutList[i];
      var aDash = aLayout.GetParentConnectorDashStyle();
      if (aDash == null) return null;
      if (dashSetting == null) dashSetting = aDash;
      else if (dashSetting != aDash) return null;
    }

    return dashSetting;
  }

  OverrideWeightStyle() {
    var layoutList = this.fAssociatedLayouts;
    if (layoutList == null) return null;

    var n = layoutList.length;
    var weightSetting = null;

    for (var i = 0; i < n; i++) {
      var aLayout = layoutList[i];
      var aWeight = aLayout.GetParentConnectorWeight();
      if (aWeight == null) return null;
      if (weightSetting == null) weightSetting = aWeight;
      else if (weightSetting != aWeight) return null;
    }

    return weightSetting;
  }

  OverrideColor() {
    var layoutList = this.fAssociatedLayouts;
    if (layoutList == null) return null;

    var n = layoutList.length;
    var colorSetting = null;

    for (var i = 0; i < n; i++) {
      var aLayout = layoutList[i];
      var color = aLayout.GetParentConnectorColor();
      if (color == null) return null;
      if (colorSetting == null) colorSetting = color;
      else if (colorSetting != color) return null;
    }

    return colorSetting;
  }

  GetActualDashStyle() {
    var style1 = this.OverrideDashStyle();
    if (style1 == null) style1 = this.GetConnectorDashStyle();
    return style1;
  }

  DoRenderElement(drawBuffer) {
    if (this.IsSelected()) {
      //console.log("Line is selected");
      return;
    }

    var fillMode = this.GetConnectingLineFillMode();
    if (fillMode == enumFillMode.solidFill) {
      var fillColor = this.GetConnectingLineColor();
      var dashStyle = this.GetActualDashStyle();
      if (dashStyle != enumDashStyle.nodraw) {
        var doDash = this.GetActualDashStyle() != enumDashStyle.nodash;
        this.DrawConnectingLine(drawBuffer, fillColor, doDash, false);
      }
    }
  }

  //=================================================================================================
  DoAltRender(altCanvas) {
    var fillMode = this.GetConnectingLineFillMode();
    if (fillMode == enumFillMode.solidFill) {
      var thickness = this.GetConnectingLineThickness();
      var lineColor = this.GetConnectingLineColor();

      var ds = this.GetActualDashStyle();
      if (ds == enumDashStyle.nodraw) return;

      var dashed = ds != enumDashStyle.nodash;

      var r = new QRect();
      var altCanvasType = altCanvas.GetCanvasType();
      var altCanvasElement = altCanvas.GetCanvasElement();

      switch (altCanvasType) {
        case "SVG":
          this.GetLineRect(r);
          SVG_DrawLine(
            r.fLeft,
            r.fTop,
            r.fRight,
            r.fBottom,
            lineColor,
            thickness,
            dashed,
            false,
            altCanvasElement
          );
          break;
        case "XML":
          this.GetLineRectAlt(r);
          var theLayer = this.GetLayer();
          XML_DrawLine(
            r.fLeft,
            r.fTop,
            r.fRight,
            r.fBottom,
            lineColor,
            thickness,
            dashed,
            altCanvasElement,
            theLayer
          );
          break;
      }
    }
  }

  //=================================================================================================
  // Standard Rendering
  GetConnectorDashStyle() {
    return this.fConnectingLineGroup.GetConnectorDashStyle();
  }

  SetConnectorDashStyle(dashStyle) {
    this.fConnectingLineGroup.SetConnectorDashStyle(dashStyle);
  }

  GetParentConnectorDashStyle() {
    return this.OverrideDashStyle();
  }

  SetParentConnectorDashStyle(dashStyle) {
    var layoutList = this.fAssociatedLayouts;
    if (layoutList == null) return;

    var n = layoutList.length;
    for (var i = 0; i < n; i++) {
      var aLayout = layoutList[i];
      var aDash = aLayout.SetParentConnectorDashStyle(dashStyle);
    }
  }

  SetConnectingLineThickness(thickness) {
    this.fConnectingLineGroup.SetConnectingLineThickness(thickness);
  }

  GetConnectingLineThickness() {
    var overrideStyle = this.OverrideWeightStyle();
    if (overrideStyle != null) return overrideStyle;
    return this.fConnectingLineGroup.GetConnectingLineThickness();
  }

  SetConnectingLineColor(lineColor) {
    this.fConnectingLineGroup.SetConnectingLineColor(lineColor);
  }

  GetConnectingLineColor() {
    var overrideColor = this.OverrideColor();
    if (overrideColor != null) return overrideColor;
    return this.fConnectingLineGroup.GetConnectingLineColor();
  }

  SetConnectingLineFillMode(fillMode) {
    this.fConnectingLineGroup.SetConnectingLineFillMode(fillMode);
  }

  GetConnectingLineFillMode() {
    return this.fConnectingLineGroup.GetConnectingLineFillMode();
  }

  RenderSelectionHighlight(drawBuffer, fillColor) {
    var fillColor = this.GetConnectingLineColor();
    var fillMode = this.GetConnectingLineFillMode();

    // Need to update when we support background colors other than white
    if (fillMode == enumFillMode.noFill || fillColor == "#FFFFFF") fillColor = "#000000";

    this.DrawConnectingLine(drawBuffer, fillColor, false, true);
  }

  // Debugging
  ObjectName() {
    return "QConnectingLine";
  }
}
